import { render, staticRenderFns } from "./DimensionsForm.vue?vue&type=template&id=7faf6eda&scoped=true&"
import script from "./DimensionsForm.vue?vue&type=script&lang=js&"
export * from "./DimensionsForm.vue?vue&type=script&lang=js&"
import style0 from "./DimensionsForm.vue?vue&type=style&index=0&id=7faf6eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faf6eda",
  null
  
)

export default component.exports